import { useState } from "react";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";

/**
 * Simple front-end contact form. Uses mailto: for now — no new backend API.
 * When Emergent-managed email is added later, swap the submit handler.
 */
export default function ContactForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) {
      toast.error("Fill in name, email, and message.");
      return;
    }
    const subject = encodeURIComponent(`BRep contact — ${name}`);
    const body = encodeURIComponent(`${message}\n\n— ${name}\n${email}`);
    window.location.href = `mailto:hello@thebrep.app?subject=${subject}&body=${body}`;
    toast.success("Opening your email client…");
  };

  return (
    <form onSubmit={submit} className="border border-white/10 p-6 md:p-10" data-testid="contact-form">
      <div className="mb-6">
        <label className="text-[10px] tracking-[0.32em] uppercase text-white/50">Name</label>
        <input
          type="text"
          className="input-line focus-ring"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          data-testid="contact-input-name"
        />
      </div>
      <div className="mb-6">
        <label className="text-[10px] tracking-[0.32em] uppercase text-white/50">Email</label>
        <input
          type="email"
          className="input-line focus-ring"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid="contact-input-email"
        />
      </div>
      <div className="mb-8">
        <label className="text-[10px] tracking-[0.32em] uppercase text-white/50">Message</label>
        <textarea
          rows={5}
          className="input-line focus-ring resize-none"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
          data-testid="contact-input-message"
        />
      </div>
      <button
        type="submit"
        className="btn-primary group inline-flex items-center gap-3 px-6 py-4 text-[12px] tracking-[0.22em] uppercase font-medium"
        data-testid="contact-submit"
      >
        Send Message
        <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </button>
      <p className="mt-6 text-[11px] tracking-[0.16em] text-white/40">
        Or email us directly at hello@thebrep.app
      </p>
    </form>
  );
}
